
/**
 * Client-side localization map for catalog selector and availability rule keys.
 *
 * These are merged with bridge-supplied labels/descriptions:
 *   const label = SELECTOR_DESCRIPTIONS[key]?.label || bridge.label;
 *   const desc  = SELECTOR_DESCRIPTIONS[key]?.description || bridge.description || '';
 *
 * Keys must match what the PHP bridge returns as selector_key / available_rule_key.
 */

export const SELECTOR_DESCRIPTIONS = {
  products_all: {
    label: "ui.catalogSelector.selectorDescriptions.allProducts",
    description:
      "ui.catalogSelector.selectorDescriptions.indexAllActiveProductsOnPrestaShopThisIsEquivalentTo",
  },
  products_active_only: {
    label: "ui.catalogSelector.selectorDescriptions.activeProductsOnly",
    description:
      "ui.catalogSelector.selectorDescriptions.indexOnlyProductsMarkedAsActiveSemanticallyDistinctFromAll",
  },
  products_available_only: {
    label: "ui.catalogSelector.selectorDescriptions.availableProductsOnly",
    description:
      "ui.catalogSelector.selectorDescriptions.indexOnlyProductsThatPassTheConfiguredAvailabilityRuleCombines",
  },
  categories_excluded: {
    label: "ui.catalogSelector.selectorDescriptions.excludeCategories",
    description:
      "ui.catalogSelector.selectorDescriptions.indexAllActiveProductsExceptThoseAssignedToTheSpecified",
  },
};

export const AVAILABILITY_RULE_DESCRIPTIONS = {
  ps_quantity_gt_zero: {
    label: "ui.catalogSelector.selectorDescriptions.stockQuantity0",
    description: "ui.catalogSelector.selectorDescriptions.productIsAvailableWhenItsStockQuantityIsGreaterThan",
  },
  ps_stock_flag: {
    label: "ui.catalogSelector.selectorDescriptions.stockFlagWithOrderPolicy",
    description:
      "ui.catalogSelector.selectorDescriptions.productIsAvailableWhenStockQuantity0OrWhen",
  },
  ps_available_for_order: {
    label: "ui.catalogSelector.selectorDescriptions.availableForOrderFlag",
    description:
      "ui.catalogSelector.selectorDescriptions.productIsAvailableWhenItsAvailableForOrderFlagIsSetNo",
  },
  ps_combination_in_stock: {
    label: "ui.catalogSelector.selectorDescriptions.combinationInStock",
    description:
      "ui.catalogSelector.selectorDescriptions.productIsAvailableWhenAtLeastOneActiveProductCombination",
  },
};
